import React from 'react';

import './styles/LoadingSpinner.css';

// HTML structure taken from https://github.com/loadingio/css-spinner/
const LoadingSpinner = () => (
  <div className="tvt-loading-spinner">
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
    <div className="tvt-loading-spinner__line" />
  </div>
);

export default LoadingSpinner;
